import dayjs from "dayjs";

export { bookingStatuses } from "../../helpers/helpers";

export const bookingId = row => row.booking_id || row.booking_number || row.booking_no || row.reference || row.id;
export const patientName = row => row.patient?.name || row.patient_name || row.booking_name || row.member?.name || "-";
export const packageName = row => row.package?.name || row.package_name || "-";
export const packageVariant = row => row.variation?.name || (typeof row.package_variant === "object" && row.package_variant !== null ? row.package_variant.name || "-" : row.package_variant || row.variant_name || "-");
export const assignedEmail = row => row.assigned_email || row.admin_email || row.variation?.notification_email || row.package?.notification_email || row.package?.admin_email || "-";
export const appointmentValue = row => row.scheduled_at || row.appointment_at || row.appointment_date || row.appointment_at_preferred;
export const appointmentDate = row => {
  const value = appointmentValue(row);
  return value && dayjs(value).isValid() ? dayjs(value).format("DD MMM YYYY") : "-";
};
export const appointmentTime = row => {
  const time = row.appointment_time;
  if (time) {
    const parsed = dayjs(`2000-01-01T${time}`);
    return parsed.isValid() ? parsed.format("h:mm A") : time;
  }
  const value = appointmentValue(row);
  return value && /[T ]\d{2}:\d{2}/.test(value) && dayjs(value).isValid() ? dayjs(value).format("h:mm A") : "-";
};

function csvCell(value) {
  let text = String(value ?? "");
  if (/^[\s]*[=+@-]/.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
}

export function bookingsCsv(rows) {
  const data = [["Booking ID", "Patient", "Package", "Variant", "Appointment Date", "Appointment Time", "Assigned Email", "Status"],
    ...rows.map(row => [bookingId(row), patientName(row), packageName(row), packageVariant(row), appointmentDate(row), appointmentTime(row), assignedEmail(row), row.status])];
  return "\uFEFF" + data.map(row => row.map(csvCell).join(",")).join("\r\n");
}

export function downloadBookingsCsv(rows) {
  const file = rows instanceof Blob ? rows : new Blob([bookingsCsv(rows)], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = url;
  link.download = "package-bookings.csv";
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
